import { EducatorPacket } from '../../../types/schema-generated-types';
import { QueryResult, useQuery, OperationVariables, ApolloError } from '@apollo/client';
import { StoreTypename } from 'types';
import GET_PACKETS from 'graph/queries/assessments/get-educator-packets';

export type EducatorPacketStoreState = {
  educatorPackets: EducatorPacket[];
  isLoading: boolean;
  error?: ApolloError;
};

export type EducatorPacketStoreDispatch = {
  educatorPacketRefetch: any;
};

export type EducatorPacketStore = [EducatorPacketStoreState, EducatorPacketStoreDispatch];

export const getDefaultEducatorPacketStoreState = (): any => ({
  __typename: StoreTypename.EDUCATOR_PACKET,
});

export const useEducatorPacketStore = (productCurriculumId: number | null): EducatorPacketStore => {
  const {
    data,
    loading,
    error,
    refetch: educatorPacketRefetch,
  }: QueryResult<{ educatorPackets: EducatorPacket[] }> = useQuery(GET_PACKETS, {
    variables: { where: { productCurriculumId: productCurriculumId } } as OperationVariables,
    skip: !productCurriculumId,
  });

  const educatorPackets = data?.educatorPackets ?? [];

  return [{ educatorPackets, isLoading: loading, error }, { educatorPacketRefetch }];
};
